const namespace = 'recoveryCodes';

export const SET_RECOVERY_CODES_SAVED = `${namespace}/SET_RECOVERY_CODES_SAVED`;
export const SET_RECOVERY_CODE_IDS = `${namespace}/SET_RECOVERY_CODE_IDS`;
export const SET_PROVISIONING_URI = `${namespace}/SET_PROVISIONING_URI`;
export const FETCH_ACCOUNT_RECOVERY_CODES = `${namespace}/FETCH_ACCOUNT_RECOVERY_CODES`;
export const FETCH_RECOVERY_CODES = `${namespace}/FETCH_RECOVERY_CODES`;
export const DOWNLOAD_ACCOUNT_RECOVERY_CODES = `${namespace}/DOWNLOAD_ACCOUNT_RECOVERY_CODES`;
export const DOWNLOAD_RECOVERY_CODES = `${namespace}/DOWNLOAD_RECOVERY_CODES`;
